import * as React from 'react'
import Loadable from 'react-loadable'
import { Container } from './container'
import { reloadStyles } from '../lib/realod-styles'

import '../sass/loading.scss'

const loading = (props) => {
  if (props.error) {
    // When the loader has errored
    return (
      <Container name='loading'>
        <button className='button btn-outline-primary' onClick={props.retry}>
          Retry
        </button>
      </Container>
    )
  } else if (props.pastDelay) {
    // When the loader has taken longer than the delay
    return (
      <Container name='loading'>
        <div className='spinner'>
          <div className='bounce1 accentPrimary' />
          <div className='bounce2 accentPrimary' />
          <div className='bounce3 accentPrimary' />
        </div>
      </Container>
    )
  }
  // default blank page, before delay
  return <Container name='loading' />
}

export const LoadableOnlineMain = Loadable({
  loader: () =>
    import(/* webpackChunkName: "widget-online" */ './online/online').then(
      (c) => {
        reloadStyles()
        return c
      }
    ),
  render(loaded, props) {
    const Component = loaded['OnlineMain']
    return <Component {...props} />
  },
  loading,
  delay: 300
})

export const LoadableOnlineInCall = Loadable({
  loader: () =>
    import(/* webpackChunkName: "widget-online" */ './online/online').then(
      (c) => {
        reloadStyles()
        return c
      }
    ),
  render(loaded, props) {
    const Component = loaded['InCall']
    return <Component {...props} />
  },
  loading,
  delay: 300
})

export const LoadableEmailTranscript = Loadable({
  loader: () =>
    import(/* webpackChunkName: "widget-online" */ './online/online').then(
      (c) => {
        reloadStyles()
        return c
      }
    ),
  render(loaded, props) {
    const Component = loaded['EmailTranscript']
    return <Component {...props} />
  },
  loading,
  delay: 300
})

export const LoadableAnswersMain = Loadable({
  loader: () =>
    import(/* webpackChunkName: "widget-answers" */ './answers/answers').then(
      (c) => {
        reloadStyles()
        return c
      }
    ),
  render(loaded, props) {
    const Component = loaded['AnswersMain']
    return <Component {...props} />
  },
  loading,
  delay: 300
})

export const LoadableArticleList = Loadable({
  loader: () =>
    import(/* webpackChunkName: "widget-answers" */ './answers/answers').then(
      (c) => {
        reloadStyles()
        return c
      }
    ),
  render(loaded, props) {
    const Component = loaded['ArticleList']
    return <Component {...props} />
  },
  loading,
  delay: 300
})

export const LoadableDetails = Loadable({
  loader: () =>
    import(/* webpackChunkName: "widget-answers" */ './answers/answers').then(
      (c) => {
        reloadStyles()
        return c
      }
    ),
  render(loaded, props) {
    const Component = loaded['Details']
    return <Component {...props} />
  },
  loading,
  delay: 300
})

export const LoadableSearchResults = Loadable({
  loader: () =>
    import(/* webpackChunkName: "widget-answers" */ './answers/answers').then(
      (c) => {
        reloadStyles()
        return c
      }
    ),
  render(loaded, props) {
    const Component = loaded['SearchResults']
    return <Component {...props} />
  },
  loading,
  delay: 300
})
